// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

import type { StateType, DispatchType } from "../../../global/types/redux";
import type { ChartType } from "../../../global//types/BillingChartType";
import BillingTable from "../../components/billings/BillingTable";
import { fetchHistoryBilling } from "../../actions/billingActions";

type HistoryBillingLogsPropsType = {
  date: string,
  historyBillings: Array<{ [key: string]: * }>,
  total: string,
  billingId: string,
  companies: Array<{ [key: string]: * }>,
  isAdmin?: boolean,
  companyId?: string,
  actions: { fetchHistoryBilling: Function }
};

class HistoryBillingLogs extends Component<HistoryBillingLogsPropsType, *> {
  getBilling = (): * => {
    let billing;
    if (this.props.isAdmin) {
      let companies = [...this.props.companies];
      let index = companies.findIndex(x => x.id === this.props.companyId);
      let company = { ...companies[index] };

      let billings = [...company.history];
      let index2 = billings.findIndex(x => x.id === this.props.billingId);
      billing = billings[index2];
    } else {
      let index = this.props.historyBillings.findIndex(
        x => x.id === this.props.billingId
      );
      billing = this.props.historyBillings[index];
    }
    return billing;
  };

  componentDidMount() {
    const billing = this.getBilling();

    if (!billing.logs) {
      this.props.actions.fetchHistoryBilling(
        this.props.billingId,
        this.props.isAdmin ? this.props.companyId : undefined
      );
    }
  }

  render(): React$Element<*> {
    const billing = this.getBilling();

    let charts = [];
    billing.logs &&
      billing.logs.forEach(
        (item: *, i: number): * => {
          charts.push({
            id: item.partNo,
            name: item.name,
            count: item.count,
            price: item.price,
            total: item.summary
          });
        }
      );

    return (
      <div className="app-wrapper">
        <div className="app-panel">
          <div className="app-panel-content">
            <Paper className="box-wrapper">
              <Typography variant="h5" className="form-text">
                Full Bill for {this.props.date}
              </Typography>
              <BillingTable charts={charts} total={this.props.total} />
            </Paper>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: StateType): * => ({
  historyBillings: state.v3account.billing.historyBillings,
  companies: state.v3admin.billing.companies
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ fetchHistoryBilling }, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HistoryBillingLogs);
